import { getContactCategoriesAction } from "../../../Actions/LogicActions/NeedHelp/GetContactCategoriesAction";
import { handleSubmitContactAction } from "../../../Actions/UIActions/NeedHelp/HandleSubmitContactFormAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import {
  IContactParams,
} from "../../../Orchestrator/Types/Interface/ICustomerContact";

class CustomerContactInitStep extends StepFlow {
  get stepName() {
    return "CustomerContactInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.NeedHelp.CustomerContact.Categories.Get,
        handler: async () => {
          await getContactCategoriesAction.execute();
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<IContactParams, void>({
        eventName: evtTree.NeedHelp.CustomerContact.Submit.Click,
        handler: async (data) => {
          if (data.data) {
            handleSubmitContactAction.setParams(data.data!);
            handleSubmitContactAction.execute(); 
          }
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log(
      "CustomerContact Init Step Execute............................."
    );
    _eventBus.emit({
      eventName: evtTree.NeedHelp.CustomerContact.Categories.Get,
    });
    // Run the event to get the CustomerContact session

    // sessionStorage.setItem("hideCustomerContact", "true");
    /**
     * Below code is to handle auto open destination popup for location selection
     * From Origin step it's return a init step of search
     * Here in init we check origin is already selected then tear down the init step automatically
     * and it's start destination step.
     */
  }
}

export const CustomerContactInitStepDeclaration = new StepDefinition({
  stepName: "CustomerContactInit_Step",
  stepClass: CustomerContactInitStep,
});
